// Customer Support Chatbot Data
// This file contains all FAQs, suggestions, and contact information

export const faqs = [
  {
    keywords: ['hello', 'hi', 'hey', 'greetings'],
    answer: "Hello! Welcome to AkkoRent. How can I assist you today? You can ask me about rentals, payments, returns, or any other questions.",
    relatedQuestions: ["How to rent a product?", "What payment methods do you accept?", "What is your return policy?"]
  },
  {
    keywords: ['rent', 'rental', 'how to rent', 'renting'],
    answer: "To rent a product:\n1. Browse our products catalog\n2. Select the item you want\n3. Choose rental duration\n4. Add to cart and checkout\n5. Complete payment\n\nYou can pick up the item or choose delivery!",
    relatedQuestions: ["What payment methods do you accept?", "What is the rental duration?", "Do you offer delivery?"]
  },
  {
    keywords: ['payment', 'pay', 'payment method', 'how to pay'],
    answer: "We accept multiple payment methods:\n• Credit/Debit Cards\n• UPI (Google Pay, PhonePe, Paytm)\n• Net Banking\n• Wallets\n\nAll transactions are secure and encrypted.",
    relatedQuestions: ["What about security deposit?", "How to rent a product?", "What are the charges?"]
  },
  {
    keywords: ['return', 'returning', 'give back', 'return policy'],
    answer: "Return Policy:\n• Return items before the rental period ends to avoid extra charges\n• Items should be in the same condition as received\n• Late returns incur additional charges\n• Damaged items may have deduction fees\n\nContact us for return scheduling!",
    relatedQuestions: ["What if item is damaged?", "What are late fees?", "How to extend rental?"]
  },
  {
    keywords: ['delivery', 'shipping', 'deliver'],
    answer: "Delivery Options:\n• Free delivery for orders above ₹500\n• Standard delivery: 2-3 business days\n• Express delivery: Same day/Next day (additional charges)\n• You can also choose self-pickup\n\nDelivery charges vary by location.",
    relatedQuestions: ["How to track my order?", "What are the charges?", "Service locations"]
  },
  {
    keywords: ['cancel', 'cancellation', 'cancel order'],
    answer: "Cancellation Policy:\n• Free cancellation up to 24 hours before rental start\n• 50% refund if cancelled within 12-24 hours\n• No refund for cancellations within 12 hours\n\nGo to 'My Orders' to cancel.",
    relatedQuestions: ["What is your return policy?", "How to track my order?", "What about security deposit?"]
  },
  {
    keywords: ['damage', 'damaged', 'broken'],
    answer: "If you receive a damaged item:\n1. Don't accept the delivery\n2. Take photos immediately\n3. Contact us within 24 hours\n4. We'll arrange replacement or full refund\n\nFor damage during rental, charges may apply.",
    relatedQuestions: ["What is your return policy?", "Contact support", "What about warranty?"]
  },
  {
    keywords: ['account', 'profile', 'login', 'signup', 'register'],
    answer: "Account Management:\n• Create account using email/phone\n• Manage profile in 'My Account'\n• Track orders and rental history\n• Save addresses for quick checkout\n• Update payment methods\n\nClick 'Login' to get started!",
    relatedQuestions: ["How to rent a product?", "How to track my order?", "What payment methods do you accept?"]
  },
  {
    keywords: ['duration', 'rental period', 'how long'],
    answer: "Rental Duration:\n• Minimum: 1 day\n• Maximum: 30 days\n• You can extend rental before it ends\n• Late returns have additional charges\n\nCheck product page for specific duration options.",
    relatedQuestions: ["How to extend rental?", "What are late fees?", "What are the charges?"]
  },
  {
    keywords: ['deposit', 'security deposit', 'refund'],
    answer: "Security Deposit:\n• Refundable deposit required for some items\n• Amount varies by product value\n• Refunded within 3-5 days after return\n• Deductions for damages or late returns\n\nDeposit details shown during checkout.",
    relatedQuestions: ["What is your return policy?", "What payment methods do you accept?", "What are the charges?"]
  },
  {
    keywords: ['seller', 'rent out', 'list product', 'become seller'],
    answer: "Want to rent out your items?\n1. Click 'RentOut' in navigation\n2. Create seller account\n3. List your products with details\n4. Set rental prices and terms\n5. Start earning!\n\nEarn money from items you don't use regularly!",
    relatedQuestions: ["What are the charges?", "How to create account?", "Contact support"]
  },
  {
    keywords: ['track', 'tracking', 'order status', 'where is my order'],
    answer: "Track Your Order:\n1. Go to 'My Orders'\n2. Select your order\n3. View real-time status\n4. Get delivery updates via SMS/Email\n\nYou'll receive tracking details after order confirmation.",
    relatedQuestions: ["Delivery options", "How to cancel order?", "Contact support"]
  },
  {
    keywords: ['price', 'cost', 'charges', 'how much'],
    answer: "Pricing:\n• Rental prices shown per day/week/month\n• Additional charges: delivery, security deposit\n• Discounts on longer rental periods\n• No hidden fees\n\nCheck product page for detailed pricing.",
    relatedQuestions: ["Any discounts available?", "What about security deposit?", "What is the rental duration?"]
  },
  {
    keywords: ['available', 'availability', 'in stock'],
    answer: "Product Availability:\n• Real-time availability shown on product page\n• Set alerts for out-of-stock items\n• Check availability by location\n• Reserve items in advance\n\nBrowse our catalog to see what's available!",
    relatedQuestions: ["Service locations", "How to rent a product?", "Delivery options"]
  },
  {
    keywords: ['contact', 'support', 'help', 'customer service'],
    answer: "Contact Us:\n📞 Helpline: +91-8766719349\n📧 Email: support@akkorent.in\n⏰ Hours: Mon-Sat, 9 AM - 6 PM\n\nOur team is ready to assist you with any questions or concerns!",
    relatedQuestions: ["How to track my order?", "What is your return policy?", "How to rent a product?"]
  },
  {
    keywords: ['warranty', 'guarantee'],
    answer: "Warranty Information:\n• All products are quality checked before rental\n• Manufacturing defects covered\n• Wear and tear not covered\n• Report issues within 24 hours\n\nWe ensure you get the best quality products!",
    relatedQuestions: ["What about product quality?", "What if item is damaged?", "Contact support"]
  },
  {
    keywords: ['late', 'late fee', 'extend'],
    answer: "Late Returns & Extensions:\n• Extend rental before due date to avoid late fees\n• Late fees: ₹100/day or 10% of daily rental (whichever is higher)\n• Extension subject to availability\n• Contact support for extension\n\nPlan your rentals wisely!",
    relatedQuestions: ["What is the rental duration?", "What is your return policy?", "Contact support"]
  },
  {
    keywords: ['discount', 'offer', 'promo', 'coupon'],
    answer: "Discounts & Offers:\n• Check homepage for current offers\n• Long-term rentals get better rates\n• First-time user discounts available\n• Referral bonuses\n• Seasonal sales\n\nSave more with AkkoRent!",
    relatedQuestions: ["What are the charges?", "What is the rental duration?", "How to rent a product?"]
  },
  {
    keywords: ['location', 'area', 'city', 'where', 'service location'],
    answer: "Service Locations:\n• Currently serving major cities\n• Check availability by entering PIN code\n• Expanding to more locations soon\n• Some items available for pan-India delivery\n\nEnter your location during checkout!",
    relatedQuestions: ["Delivery options", "Product availability", "Contact support"]
  },
  {
    keywords: ['quality', 'condition', 'new', 'used'],
    answer: "Product Quality:\n• All items thoroughly inspected\n• Sanitized before each rental\n• Minor usage marks may be present\n• Condition clearly mentioned on listing\n• Report any issues immediately\n\nQuality guaranteed!",
    relatedQuestions: ["What about warranty?", "What if item is damaged?", "How to rent a product?"]
  },
  {
    keywords: ['refund'],
    answer: "Refund Policy:\n• Cancellation refunds processed within 5-7 business days\n• Security deposit refunded after item return inspection\n• Damaged items may have deductions\n• Refund to original payment method\n\nRefunds are processed promptly!",
    relatedQuestions: ["What is your cancellation policy?", "What about security deposit?", "Contact support"]
  }
];

// Quick suggestion questions
export const suggestions = [
  "How to rent a product?",
  "Payment methods",
  "Return policy",
  "Track my order",
  "Become a seller",
  "Contact support"
];

// Contact Information
export const contactInfo = {
  helpline: '+91-8766719349',
  email: 'support@akkorent.in',
  hours: 'Mon-Sat, 9 AM - 6 PM'
};

// Welcome message
export const welcomeMessage = "👋 Hi! I'm AkkoRent's virtual assistant. How can I help you today?";

// Fallback message when no answer is found
export const getFallbackMessage = () => {
  return `I couldn't find an answer to your question. 😔\n\nFor personalized assistance, please contact our support team:\n\n📧 Email: ${contactInfo.email}\n⏰ Hours: ${contactInfo.hours}\n\nWe're here to help!`;
};

// Contact information message (used when user asks for contact/support)
export const getContactMessage = () => {
  return `📞 Contact AkkoRent Support:\n\nHelpline: ${contactInfo.helpline}\nEmail: ${contactInfo.email}\nHours: ${contactInfo.hours}\n\nOur team is ready to assist you with any questions or concerns!`;
};

// Seller specific welcome message
export const sellerWelcomeMessage = "👋 Hello Partner! I'm your Seller Success Assistant. How can I help you grow your business today?";
